import Link from "next/link"
import { Breadcrumb, Col, Row, Typography } from "antd"
import PropTypes from "prop-types"

BreadcrumbHeading.propTypes = {
  extra: PropTypes.any,
  home: PropTypes.any,
  itemsList: PropTypes.array,
  onOpenValorations: PropTypes.func
}

export function BreadcrumbHeading({ extra, home, itemsList, onOpenValorations }) {
  return (
    <Row justify="space-between" align="middle">
      <Col>
        <Breadcrumb>
          <Breadcrumb.Item>
            <Link href={home.url}>
              {home.label}
            </Link>
          </Breadcrumb.Item>
          {itemsList?.map((item, index) =>
            <Breadcrumb.Item key={index}>
              <Link href={item.url}>
                {item.label}
              </Link>
            </Breadcrumb.Item>
          )}
        </Breadcrumb>
      </Col>
      <Col>
        {home?.url?.split("/")[1] === "implementer" ? <></> : 
        <Typography.Link
          style={{color: "#612F5E"}}
          onClick={onOpenValorations}>
          Ver valoraciones
        </Typography.Link>}
        {extra}
      </Col>
    </Row>
  )
}
